/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Inline, Text } from '@atlaskit/primitives/compiled';

type EntityTitleProps = {
	icon?: ReactNode;
	title: ReactNode;
};

export const EntityTitle = ({ icon, title }: EntityTitleProps): JSX.Element => (
	<Inline space="space.100" alignBlock="center">
		{icon}
		<Heading size="xsmall">
			<Text maxLines={1} weight="semibold">
				{title}
			</Text>
		</Heading>
	</Inline>
);
